/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import "./building-material-component.scss";
import { StaticAlert, CheckboxPart, Textarea } from "components";
import { Field } from "formik";

interface BuildingMaterialComponentType {
  field: any;
  errors?: any;
  form: any;
}

const BuildingMaterialComponent = ({
  field,
  form,
  errors,
}: BuildingMaterialComponentType) => {
  const [buildingMaterialObject, setBuildingMaterialObject] = useState(
    form.values.theBuildingIsMadeOf || ""
  );

  useEffect(() => {
    setBuildingMaterialObject(form.values.theBuildingIsMadeOf);
  }, [form.values[field.name]]);

  const isAvailableComment = buildingMaterialObject === "other";
  const BuildingMaterialCheckbox = [
    {
      label: "Pustak ceramiczny",
      value: "ceramicBlock",
      uuid: "ceramicBlock",
    },
    {
      label: "Konstrukcja drewniana",
      value: "woodenStructure",
      uuid: "woodenStructure",
    },
    {
      label: "Y-tong",
      value: "yTong",
      uuid: "yTong",
    },
    {
      label: "Silikat",
      value: "silicate",
      uuid: "silicate",
    },
    {
      label: "Inne",
      value: "other",
      uuid: "other",
    },
  ];

  const handleCheckMaterial = (item: any) => {
    if (buildingMaterialObject === item.value) {
      setBuildingMaterialObject("");
    } else {
      setBuildingMaterialObject(item.value);
    }
  };

  useEffect(() => {
    form.setFieldValue(field.name, buildingMaterialObject);
  }, [buildingMaterialObject]);

  return (
    <div className="building-material-component">
      <div className="am-section-heading">
        Materiał, z którego został wykonany budynek
      </div>
      <div className="am-section-checkbox-list construction-site__list">
        {BuildingMaterialCheckbox.map((item: any) => {
          return (
            <CheckboxPart
              className="radiobox"
              onChange={() => handleCheckMaterial(item)}
              checked={buildingMaterialObject === item.value}
              key={item.value}
              label={item.label}
              uuid={item.value}
            />
          );
        })}
      </div>
      {errors && form.touched && (
        <>
          <StaticAlert
            className="am-alert"
            size="small"
            show={errors[field.name] && errors[field.name]}
            label="Te dane są obowiązkowe. Uzupełnij je, aby móc przejść dalej."
          />
        </>
      )}
      {isAvailableComment && (
        <Field
          name="theBuildingIsMadeOfComment"
          maxLength={240}
          component={Textarea}
        />
      )}
      <div className="am-separator" />
    </div>
  );
};

export default BuildingMaterialComponent;
